const dayFmt = new Intl.DateTimeFormat("it-IT", { day: "2-digit", month: "short" });
const timeFmt = new Intl.DateTimeFormat("it-IT", { hour: "2-digit", minute: "2-digit" });
const TONE = { STATUS_CHANGE: "bg-sky-500", ASSIGN: "bg-brand-500", LEAD_CONVERTED: "bg-emerald-500", ARCHIVED: "bg-slate-400", NEXT_ACTION: "bg-brand-500",
  OPP_CREATED: "bg-brand-500", OPP_WON: "bg-emerald-500", OPP_LOST: "bg-red-500", NEXT_ACTION_DONE: "bg-emerald-500", APPOINTMENT: "bg-sky-500",
  QUOTE_CREATED: "bg-brand-500", QUOTE_STATUS: "bg-sky-500", QUOTE_REVISION: "bg-amber-500", QUOTE_DUPLICATED: "bg-slate-400", OPP_FIELD: "bg-slate-400", APPOINTMENT_UPDATED: "bg-sky-500", APPOINTMENT_DELETED: "bg-red-500" };

export const TimelineList = ({ items }) => (
  items.length === 0 ? <p className="text-sm text-slate-500" data-testid="timeline-empty">Nessun evento registrato.</p> : (
    <ol className="relative space-y-4 before:absolute before:bottom-1 before:left-[67px] before:top-1 before:w-px before:bg-line" data-testid="timeline-list">
      {items.map((e) => (
        <li key={e.id} className="relative flex gap-4" data-testid={`timeline-event-${e.id}`}>
          <span className="w-14 shrink-0 pt-0.5 text-right font-mono text-[11px] font-semibold uppercase text-slate-500">{dayFmt.format(new Date(e.occurred_at))}</span>
          <span className={`relative z-10 mt-1.5 h-2.5 w-2.5 shrink-0 rounded-full ring-4 ring-white ${TONE[e.type] || "bg-slate-300"}`} />
          <div className="min-w-0">
            <p className="text-sm font-medium text-ink">{e.title}</p>
            <p className="text-xs text-slate-500">{[e.actor_name, timeFmt.format(new Date(e.occurred_at)), e.type === "NEXT_ACTION" && e.detail ? new Date(e.detail).toLocaleDateString("it-IT") : null].filter(Boolean).join(" · ")}</p>
          </div>
        </li>
      ))}
    </ol>
  )
);
